import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { AnalysisModule } from '../../modules/analysis/AnalysisModule.tsx';

export const AnalysisRouteElement = () => (
  <ModuleContainer moduleID="analysis" compact>
    <AnalysisModule />
  </ModuleContainer>
);
